function setDynamicBackgroundImage(imageUrl,x="200px",y=0) {
    document.querySelector('.slidepara').style.background =`url(${imageUrl})`;
    setTimeout(() => {
        x = "-10px"
        document.querySelector('.about_card').style.display = `block`;
        document.querySelector('.about_card').style.transform =`translate(${x}, ${y})`;
        document.querySelector('.about_card').style.transition= `transform 2s ease-in-out`;
        // console.log("timer1")
         
      }, 6);

      setTimeout(() => {
        // console.log("timer2")
        x = "2000px"
        y = 0
        document.querySelector('.about_card').style.transform =`translate(${x}, ${y})`;
        document.querySelector('.about_card').style.transition= `transform 2s ease-in-out`;
         
      }, 8000);

      setTimeout(() => {
        // console.log("timer1")
        x = "-500px"
        y = 0
        document.querySelector('.about_card').style.transform =`translate(${x}, ${y})`;
        document.querySelector('.about_card').style.transition= `transform 2s ease-in-out`;
         
      }, 0);

    }



export default setDynamicBackgroundImage


